<div class="font-size-picker">
  <button
    class="ds-c-button ds-c-button--ghost font-size-picker__button font-size-picker__button--small"
    (click)="handleFontSizeChange('small')">
    A
  </button>
  <button
    class="ds-c-button ds-c-button--ghost font-size-picker__button font-size-picker__button--medium"
    (click)="handleFontSizeChange('medium')">
    A
  </button>
  <button
    class="ds-c-button ds-c-button--ghost font-size-picker__button font-size-picker__button--large"
    (click)="handleFontSizeChange('large')">
    A
  </button>
</div>
